<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>C<span class="smallcaps">ONTENTS</span></span></p>
<p class="toc-text"><span><a href="#/xhtml/frantmatter01"><i>PROLOGUE</i></a></span></p>
<p class="toc-text2"><span><a href="#/xhtml/chapter001">1. <i>Our Hero</i></a></span></p>
<p class="toc-text2"><span><a href="#/xhtml/chapter002">2. <i>Into the Hall</i></a></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">3. <i>Thornmallow Gets to Class</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">4. <i>First Spell</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">5. <i>Rules</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">6. <i>Meeting</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">7. <i>Not a Wizard</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">8. <i>Classes</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">9. <i>Eavesdropping</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample">10. <i>Telling Tales</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter011" title="Link target outside of Sample">11. <i>The Master Speaks</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter012" title="Link target outside of Sample">12. <i>The Story of the Beast</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter013" title="Link target outside of Sample">13. <i>Ideas</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter014" title="Link target outside of Sample">14. <i>Library Time</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter015" title="Link target outside of Sample">15. <i>Full Moon Night</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter016" title="Link target outside of Sample">16. <i>The Master and the Beast</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter017" title="Link target outside of Sample">17. <i>Magister Hickory’s Defense</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter018" title="Link target outside of Sample">18. <i>The End of Wizard’s Hall</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter019" title="Link target outside of Sample">19. <i>Thornmallow Really Tries</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter020" title="Link target outside of Sample">20. <i>Unquilting the Beast</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter021" title="Link target outside of Sample">21. <i>Saving Wizard’s Hall</i></span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter022" title="Link target outside of Sample">22. <i>The Enhancer</i></span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample"><i>A Personal History by Jane Yolen</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?53e464bb